// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-button[data-v-772861b0] {\n  justify-content: flex-end !important;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  background-size: 100% 100%;\n  background-position: 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
